import "./LauncherAnimation.scss";

export default function LauncherAnimation(props) {
  return <div id="launcherAnimation"></div>;
}
